import { gql } from "@apollo/client";

import { moduleEditingDetails } from "components/form/graphql";

export const GET_MODULE_SETTINGS = gql`
  query GetModuleSettings($id: ID!) {
    module(id: $id) {
      ...moduleEditingDetails
      moduleShares {
        id
        from {
          account {
            subdomain
          }
        }
        to {
          account {
            subdomain
          }
          space {
            id
            name
            parentSpace
          }
        }
      }
    }
  }
  ${moduleEditingDetails}
`;

export const DELETE_MODULE = gql`
  mutation DeleteModule($moduleId: ID!) {
    moduleDelete(id: $moduleId) {
      id
    }
  }
`;
